import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import logoBrimExplorer from "@/assets/logo-brim-explorer.png";
import logoAesen from "@/assets/logo-aesen.png";
import logoStromma from "@/assets/logo-stromma.png";
import logoEnergimyndigheten from "@/assets/logo-energimyndigheten.png";
import logoVinnova from "@/assets/logo-vinnova.png";
import logoSwedishSpaceAgency from "@/assets/logo-swedish-space-agency.png";
import logoAlilauro from "@/assets/logo-alilauro.png";
import logoErikThun from "@/assets/logo-erik-thun.png";
import logoMfShipping from "@/assets/logo-mf-shipping.png";
import logoBergenTankers from "@/assets/logo-bergen-tankers.png";

const companies = [
  { name: "Brim Explorer", logo: logoBrimExplorer, className: "scale-[1.35]" },
  { name: "Aesen", logo: logoAesen },
  { name: "Stromma", logo: logoStromma },
  { name: "Energimyndigheten", logo: logoEnergimyndigheten },
  { name: "Vinnova", logo: logoVinnova },
  { name: "Swedish Space Agency", logo: logoSwedishSpaceAgency },
  { name: "Alilauro", logo: logoAlilauro },
  { name: "Erik Thun", logo: logoErikThun, className: "scale-[1.4]" },
  { name: "MF Shipping Group", logo: logoMfShipping },
  { name: "Bergen Tankers", logo: logoBergenTankers },
];

const marqueeItems = [...companies, ...companies];

const TestimonialsSection = () => {
  const { t } = useTranslation('home');
  return (
    <section className="py-16 md:py-20 bg-surface-light overflow-hidden">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="text-center mb-16">
          <p className="text-xs font-semibold tracking-widest uppercase text-foreground mb-4">{t('testimonials.heading')}</p>
        </motion.div>
      </div>
      <div className="relative marquee-container">
        <div className="flex items-center gap-16 px-8 marquee-scroll" style={{ width: "max-content" }}>
          {marqueeItems.map((company, index) => (
            <div key={index} className="flex-shrink-0 w-[220px] h-20 flex items-center justify-center select-none rounded-lg p-3 overflow-hidden pointer-events-none md:pointer-events-auto">
              <img src={company.logo} alt={company.name} loading="eager" decoding="async" className={`w-auto object-contain grayscale opacity-60 md:hover:grayscale-0 md:hover:opacity-100 transition-all duration-500 max-h-14 md:max-h-[60px] max-w-[200px] ${company.className || ''}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
